export const ACCEPTS = {
  pdf: 'application/pdf',
  csv: 'text/comma-separated-values,application/csv,text/csv,.csv',
};
